"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonHeight = void 0;
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const buttonHeightTheme = (0, _sdsThemeInternal.themed)({
  large: 40,
  medium: 32,
  small: {
    "lodestar-light": 24,
    "ursa-light": 28
  },
  xsmall: 20
});
const getButtonHeight = _ref => {
  let {
    size,
    themeMode
  } = _ref;
  return buttonHeightTheme[size](themeMode);
};
exports.getButtonHeight = getButtonHeight;
//# sourceMappingURL=getButtonHeight.js.map